import { application } from './application'

import SnackbarFlashesController from './snackbar_flashes_controller'
application.register('snackbar-flashes', SnackbarFlashesController)

import NavbarVisibilityController from './navbar_visibility_controller'
application.register('navbar-visibility', NavbarVisibilityController)

import ImageLoadingController from './image_loading_controller'
application.register('image-loading', ImageLoadingController)

import InfiniteScrollController from './infinite_scroll_controller'
application.register('infinite-scroll', InfiniteScrollController)

import ImageShowPageController from './image_show_page_controller'
application.register('image-show-page', ImageShowPageController)

import ImageZoomController from './image_zoom_controller'
application.register('image-zoom', ImageZoomController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import ImagesIndexController from './images_index_controller'
application.register('images-index', ImagesIndexController)

import TomSelectController from './tom_select_controller'
application.register('tom-select', TomSelectController)

import AiSearchesFormController from './ai_searches_form_controller'
application.register('ai-searches-form', AiSearchesFormController)
